import { render } from "./InputTelephone.vue?vue&type=template&id=d4ece70c&scoped=true"
import script from "./InputTelephone.vue?vue&type=script&lang=js"
export * from "./InputTelephone.vue?vue&type=script&lang=js"

import "./InputTelephone.vue?vue&type=style&index=0&id=d4ece70c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ece70c"]])

export default __exports__